import RegisterSettingPage from './RegisterSettingPage.vue';
export default RegisterSettingPage;
